export default {
  default: () => import("/codebuild/output/src1971087859/src/src/layouts/default.vue").then(m => m.default || m)
}